import React, { useMemo } from 'react';
import { useClientUIContext } from '../../context/ClientByIdUIContext';
import levelsToFilter from '../../../../../constants/paymentLinks/filters/levelsToFilter';
import civilStatuses from '../../../../../constants/client/civilStatuses';
import { Box, FormGroup, FormControl, Checkbox, FormLabel, FormControlLabel, MenuItem, Select, TextField, Typography, Button, CircularProgress } from '@mui/material';
import { WidgetClientData } from '../../../../../components/widget/WidgetClientData';
import '../../../../../styles/sass/clients/clientForm.scss';
import { useTranslation } from 'react-i18next';
import { levels } from '../../../../../constants/paymentLinks/level';
import { palette } from '../../../../../styles/theme';

export default function GeneralSection ({ client, handleCancel, handleSubmit }) {
    const { t } = useTranslation();
    const isDisabled = true; // TODO: change this to false when the API is ready
    // State

    // Context State
    const clientUIContext = useClientUIContext();
    const clientUIProps = useMemo(() => {
        return {
            isLoading: clientUIContext.isLoading,
            setIsLoading: clientUIContext.setIsLoading,
            clientGeneral: clientUIContext.clientGeneral,
            setClientGeneral: clientUIContext.setClientGeneral
        };
    }, [clientUIContext]);

    // eslint-disable-next-line no-unused-vars
    const telephoneWithoutCountryCode = (clientUIProps?.clientGeneral?.telephone)?.startsWith('+549') ? clientUIProps?.clientGeneral?.telephone.slice(4) : clientUIProps?.clientGeneral?.telephone;

    // Handlers

    // const handleToggleDevice = deviceId => {
    //     const newDevices = clientUIProps.clientGeneral.devices.map(({ ...device }) => {
    //         if (device.id === deviceId) {
    //             device.blocked = device.blocked === 0 ? 1 : 0;
    //         }

    //         return device;
    //     });
    //     clientUIProps.setClientGeneral({ ...clientUIProps.clientGeneral, devices: newDevices });
    // };

    // Main Component
    return (
        <Box>
            <Box display='flex' margin='34px 0px' justifyContent='start' gap='108px'>
                <Box display='flex' gap='13px'>
                    <WidgetClientData title={t('details.inputs.document')} value={client.dni} altBorder/>
                    <WidgetClientData title={t('details.inputs.cuit')} value={client.cuil} altBorder/>
                    <WidgetClientData title={t('details.inputs.nationality')} value={client.nationality} border={false} altBorder/>
                </Box>
                <FormControl component="fieldset">
                    <FormLabel >{t('details.extra.title')}</FormLabel>
                    <FormGroup aria-label="position" row>
                        <FormControlLabel
                            checked={client.FATCA}
                            control={<Checkbox color='secondary' style={{ color: isDisabled ? palette.secondary[200] : palette.secondary[600] }} />}
                            label="FACTA"
                            labelPlacement="end"
                            disabled={isDisabled}
                        />
                        <FormControlLabel
                            checked={client.PEP}
                            control={<Checkbox color='secondary' style={{ color: isDisabled ? palette.secondary[200] : palette.secondary[600] }} />}
                            label="PEP"
                            labelPlacement="end"
                            disabled={isDisabled}
                        />
                        <FormControlLabel
                            checked={client.reporting_parties}
                            control={<Checkbox color='secondary' style={{ color: isDisabled ? palette.secondary[200] : palette.secondary[600] }} />}
                            label={t('details.extra.subject')}
                            labelPlacement="end"
                            disabled={isDisabled}
                        />
                    </FormGroup>
                </FormControl>
            </Box>
            <Box display='flex' flexWrap='wrap' gap='16px'>
                <Box display='flex' flexDirection='column' gap='8px' width='427px' >
                    <Typography variant='body1' >{t('details.inputs.gender')}</Typography>
                    <TextField
                        id="outlined-read-only-input"
                        value={clientUIProps.clientGeneral.gender}
                        InputProps={{
                            readOnly: true,
                            sx: {
                                color: palette.primary.main
                            }
                        }}
                        variant="outlined"
                        size="small"
                        fullWidth
                    />
                </Box>
                <Box display='flex' flexDirection='column' gap='8px' width='427px' >
                    <Typography variant='body1'>{t('details.inputs.birthdate')}</Typography>
                    <TextField
                        id="outlined-read-only-input"
                        value={clientUIProps.clientGeneral.bornDate.split('-').reverse().join('-')}
                        InputProps={{
                            readOnly: true,
                            sx: {
                                color: palette.primary.main
                            }
                        }}
                        variant="outlined"
                        size="small"
                        fullWidth
                    />
                </Box>
                <Box display="flex" flexDirection="column" gap="8px" width="427px">
                    <Typography variant="body1">{t('details.inputs.level')}</Typography>
                    <FormControl variant="outlined" size="small" fullWidth>
                        <Select
                            value={client.level}
                            InputProps={{
                                readOnly: true,
                            }}
                        >
                            {levelsToFilter.map((levelToFilter, i) => {
                                const levelStyles = levels.find(
                                    (level) => level.id === levelToFilter.value.id
                                );

                                return (
                                    <MenuItem value={levelToFilter.value.id} key={levelToFilter.value.id}>
                                        <Box display="flex" alignItems="center" gap="8px">
                                            {/* Level style */}
                                            <Box
                                                display="flex"
                                                justifyContent="center"
                                                alignItems="center"
                                                bgcolor={levelStyles.badgeStyles.backgroundColor}
                                                color={levelStyles.badgeStyles.color}
                                                width="24px"
                                                height="24px"
                                                borderRadius="50%"
                                                fontSize="12px"
                                                fontWeight={levelStyles.badgeStyles.fontWeight}
                                            >
                                                {levelToFilter.value.label.charAt(0)}
                                            </Box>
                                            <Typography>
                                                {t(`details.level.${levelToFilter.value.value}`)}
                                            </Typography>
                                        </Box>
                                    </MenuItem>
                                );
                            })}
                        </Select>
                    </FormControl>
                </Box>
                <Box display='flex' flexDirection='column' gap='8px' width='427px' >
                    <Typography variant='body1'>{t('details.inputs.maritalStatus')}</Typography>
                    <FormControl variant="outlined" size="small" fullWidth>
                        <Select
                            value={clientUIProps.clientGeneral.civilStatus}
                            style={{ color: palette.primary.main, height: '41px' }}
                            InputProps={{
                                readOnly: true,
                            }}
                            // onChange={selected => clientUIProps.setClientGeneral({ ...clientUIProps.clientGeneral, civilStatus: selected.target.value })}
                        >
                            {civilStatuses.map((civilStatus, i) => {
                                return <MenuItem
                                    value={civilStatus.value}
                                    key={i}
                                    sx= {{ color: palette.primary.main }}
                                >{t(`details.civilStatus.${civilStatus.value}`)}</MenuItem>;
                            })}
                        </Select>
                    </FormControl>
                </Box>
                <Box display='flex' flexDirection='column' gap='8px' width='427px' >
                    <Typography variant='body1'>{t('details.inputs.dwellTime')}</Typography>
                    <TextField
                        value={clientUIProps.clientGeneral.dwellTime}
                        size="small"
                        fullWidth
                        InputProps={{
                            readOnly: true,
                            sx: {
                                color: palette.primary.main
                            }
                        }}

                        disabled
                    />
                </Box>
                <Box display='flex' flexDirection='column' gap='8px' width='427px' >
                    <Typography variant='body1'>{t('details.inputs.profession')}</Typography>
                    <TextField
                        value={clientUIProps.clientGeneral.occupation}
                        variant="outlined"
                        InputProps={{
                            readOnly: true,
                            sx: {
                                color: palette.primary.main
                            }
                        }}
                        // onChange={selected => clientUIProps.setClientGeneral({ ...clientUIProps.clientGeneral, occupation: selected.target.value })}
                        size="small"
                        fullWidth
                    />
                </Box>
            </Box>
            <Box
                display='flex'
                justifyContent='flex-end'
                gap='8px'
                marginTop='40px'>
                <Button className='delete_button--cancel-disabled' onClick={handleCancel} disabled>
                    {t('buttons.discard')}
                </Button>
                <Button className="delete_button--submit-disabled" appearance="primary" onClick={handleSubmit} disabled size='small'>
                    {(clientUIProps.isLoading ? <CircularProgress size={24} style={{ color: 'white' }} />
                        : t('buttons.save'))}
                </Button>
            </Box>
        </Box>
    );
}
